import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import type { EditedLocation } from './EditPreferredLocation/EditPreferredLocation';

export const useUpdatePreferredLocationsAnalytics = () => {
  const { updateCard } = useAnalytics();

  const updatePreferredLocationsAnalytics = (
    locationTrackingList: EditedLocation[],
  ) => {
    locationTrackingList.forEach(({ updateType, kind, countryCode }) =>
      updateCard({
        actionName: updateType,
        currentPageSection: 'next role',
        customProps: {
          currentPageSubsection: 'location',
          locationType: kind,
          locationCountry: countryCode.toLowerCase(),
        },
      }),
    );
  };

  return { updatePreferredLocationsAnalytics };
};
